import { Canvas } from "@react-three/fiber"
import { CAMERA_FAR, CAMERA_NEAR } from "./camera"
import { SceneRoot } from "./SceneRoot"

/**
 * Orthographic flat canvas. Scene background is owned by SceneRoot/HandleBridge
 * so theme changes (light/dark illustration) always re-clear the GL buffer.
 */
export function IsoCanvas() {
  return (
    <Canvas
      /*
       * `flat` is not optional: R3F defaults toneMapping to ACESFilmic, which
       * crushes #ffffff to grey and shifts the accent's hue — fatal for a
       * flat-white illustration.
       */
      flat
      orthographic
      /*
       * Passing an explicit frustum sets `camera.manual = true`. Without it R3F
       * sizes the orthographic frustum in PIXELS (±size/2), so the visible world
       * would change with the canvas aspect and a square export would reframe
       * the scene. CameraRig owns the frustum in world units from here on.
       */
      camera={{
        left: -1,
        right: 1,
        top: 1,
        bottom: -1,
        near: CAMERA_NEAR,
        far: CAMERA_FAR,
      }}
      frameloop="demand"
      dpr={[1, 2]}
      gl={{ antialias: true, alpha: true }}
      style={{ width: "100%", height: "100%", display: "block", touchAction: "none" }}
    >
      <SceneRoot />
    </Canvas>
  )
}
